import Vue from 'vue'
import Vuex from 'vuex'
import { setStore, getStore } from '@utils/localStorage'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: '',
    communicationToken: '',
    cartList: {}
  },
  mutations: {
    updateUserId(state, userId) {
      state.userId = userId
    },
    updateCommunicationToken(state, communicationToken) {
      state.communicationToken = communicationToken
    },
    initCart(state) {
      let initCart = getStore('cartList')
      if (initCart) {
        state.cartList = JSON.parse(initCart)
      }
    },
    addCart(state, { shop_id, category_id, item_id, name, price, image_url }) {
      let cart = state.cartList
      let shop = (cart[shop_id] = cart[shop_id] || {})
      let category = (shop[category_id] = shop[category_id] || {})
      if (category[item_id]) {
        category[item_id]['num']++
      } else {
        category[item_id] = {
          num: 1,
          id: item_id,
          name: name,
          price: price,
          image_url: image_url
        }
      }
      state.cartList = { ...cart }
      setStore('cartList', state.cartList)
    },
    reduceCart(state, { shop_id, category_id, item_id, name, price, image_url }) {
      let cart = state.cartList
      let shop = (cart[shop_id] = cart[shop_id] || {})
      let category = (shop[category_id] = shop[category_id] || {})
      if (category && category[item_id]) {
        if (category[item_id]['num'] > 0) {
          category[item_id]['num']--
          if (category[item_id]['num'] <= 0) {
            delete category[item_id]
          }
          state.cartList = { ...cart }
          setStore('cartList', state.cartList)
        } else {
          console.log('null')
          delete category[item_id]
        }
      }
    },
    //清空当前商品的购物车信息
    cleanCart(state, { shop_id }) {
      console.log(shop_id)
      delete state.cartList[shop_id]
      state.cartList = { ...state.cartList }
      setStore('cartList', state.cartList)
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store.js